import React from 'react'

import ContactMapCard from "./ContactMapCard"
import ContactFormCard from "./ContactFormCard"

const ContactCard = () => {
    return (
        <div className="card-inner contacts animated" id="contacts-card">
            <div className="card-wrap">


                <ContactMapCard/>

                <ContactFormCard/>

            </div>

        </div>

    );
}


export default ContactCard;